import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";

const timelineData = [
  {
    company: "Simform Solutions",
    location: "Ahmedabad, Gujarat",
    duration: "Jan 2025 - Present",
    role: "Software Engineer - Fullstack",
    description:
      "Actively building foundational knowledge of the company’s full-stack ecosystem while strengthening skills in technologies like Angular, TypeScript, Node.js, and database optimization. Preparing to contribute to scalable, high-impact projects.",
  },
];

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          {timelineData.map((item, index) => (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element--work"
              contentStyle={{ background: "white", color: "#272822" }}
              contentArrowStyle={{ borderRight: "7px solid white" }}
              date={item.duration}
              iconStyle={{ background: "#5000ca", color: "#fff" }}
              icon={<FontAwesomeIcon icon={faBriefcase} />}
            >
              <h3 className="vertical-timeline-element-title">{item.role}</h3>
              <h4 className="vertical-timeline-element-subtitle">
                {item.company} — {item.location}
              </h4>
              <p>{item.description}</p>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
